<template>
    <section class="order-details">
        <ui-headline>{{ order.headline }}</ui-headline>
        <section class="order-details--top">
            <section class="order-details--img"></section>
            <section class="order-details--info">
                <section class="order-details--attributesection">
                    <section class="order-details--attribute">Order: </section>
                    <section class="">{{ order.name }}</section>
                </section>
                <section class="order-details--attributesection">
                    <section class="order-details--attribute">Created: </section>
                    <section class="">{{ order.created }}</section>
                </section>
                <section class="order-details--attributesection">
                    <section class="order-details--attribute">Sent: </section>
                    <section class=""> {{ order.sent }}</section>
                </section>
                <section class="order-details--attributesection">
                    <section class="order-details--attribute">User: </section>
                    <section class="">{{ order.user }}</section>
                </section>
                <section class="order-details--attribute">
                    <span>Vendor:</span>
                    <select>
                      <option value="choice">{{ order.vendor }} - $00.00</option>
                    </select>
                </section>
                <section class="order-details--attribute">Fund Distribution:</section>
                <section class="order-details--scrollbox">
                    <ui-checklist :items="['Medical', 'History', 'Arts', 'Engineering']"></ui-checklist>
                </section>

                <section class="order-details--checkedboxes">
                    <section class="order-details--checkedbox__percentage">Medical %</section>
                    <section class="order-details--checkedbox__percentage">Engineering %</section>
                </section>
            </section>
        </section>

        <hr>
            <section class="order-details--totalpricesection">
                <section class="order-details--totalprice">{{ order.price }}</section>
                <section class="order-details--label">Total price</section>
            </section>
        <hr>

            <section class="order-details--buttons">
                <div class="order-details--buttons__item"><ui-button title="Send"></ui-button></div>
                <div class="order-details--buttons__item"><ui-button title="Reorder"></ui-button></div>
                <div class="order-details--buttons__item"><ui-button title="Cancel"></ui-button></div>
                <div class="order-details--buttons__item"><ui-button title="Edit"></ui-button></div>
                <div class="order-details--buttons__item"><ui-button title="Delete"></ui-button></div>
            </section>

    </section>
</template>

<script>
    export default {
        name: 'order-details',
        props: ['order'],
    }
</script>

<style>

.order-details{
    padding:10px;
    margin-bottom: 30px;
}

.order-details--top{
    display:flex;
    align-items: column;
    width:100%;

}

.order-details--img{
    display:block;
height: 160px;
min-width:120px;
background-color:rgba(0,0,0,0.5);
border: 1px solid rgba(0,0,0,0.2);
box-sizing:border-box;
}

.order-details--info{
display: flex;
flex-direction: column;
margin: 0px 10px 10px 20px;


}
.order-details--attributesection{
    display:flex;
    flex-direction:column;
    margin-bottom: 10px;
}

.order-details--scrollbox{
    border: solid 1px grey;
    width: 160px;
}

.order-details--checkedboxes{
    display:flex;
}

.order-details--checkedbox__percentage{
    border: solid 1px grey;
    color: grey;
    padding: 4px;
    margin: 10px 0px 0px 0px;
    width:115px;
    margin-right: 10px;
}


.order-details--attribute{
    margin-bottom: 6px;
    font-weight:bold;
}

.order-details--buttons{
    display:flex;
    margin-left: -6px;
    margin-right: -6px;
}
.order-details--buttons__item {
    flex: 1;
    padding: 0 6px;
}

.order-details--buttons__item button {
    width: 100%;
}

.order-details--totalpricesection{
    display:flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.order-details--totalprice{
    font-size:1.2em;
    font-weight:bold;
}
.order-details--label{
    color:grey;
}

</style>



// WEBPACK FOOTER //
// OrderDetails.vue?e41d4ad6